// Bilkravet på ordren (truckCategory hardt, truckAxlesMin mykt) mot sjåførens kjøretøy (vehicles: type, axles, hasTrailer). truckTrailer på ordren krever hasTrailer.
// Samme regel finnes i functions/src/truckMatching.js (separat pakke). Hold dem like.

export function vehicleMeetsTruckRequirement(vehicle, order) {
  if (!order?.truckCategory) return true;
  if (vehicle?.type !== order.truckCategory) return false;
  // Ordre med henger (truckTrailer): kjøretøyet må ha henger (hasTrailer). Eldre kjøretøy uten feltet regnes som uten henger.
  if (order.truckTrailer === true && vehicle?.hasTrailer !== true) return false;
  const min = order.truckAxlesMin;
  // Kjøretøy uten registrerte aksler (eldre) regnes som oppfylt, så ingen får færre oppdrag enn før.
  if (min != null && vehicle.axles != null && vehicle.axles < min) return false;
  return true;
}

// En sjåfør uten kjøretøy (eller mens de lastes) skjules ikke: profilkravene fanger det opp andre steder.
export function driverCanServeOrder(order, vehicles) {
  if (!order?.truckCategory) return true;
  const list = Array.isArray(vehicles) ? vehicles : [];
  if (list.length === 0) return true;
  return list.some(v => vehicleMeetsTruckRequirement(v, order));
}
